/* eslint-disable no-unused-vars */
import React, { useState, useCallback, memo } from "react";
import DislikeModule from "./DislikeModule";
import { useLocation, useNavigate } from "react-router-dom";
import { saveAppLevelFeedBack } from "../Services/ApiServices/chatServices";
import { apiError } from "../Services/Redux/Reducers/chatSlice";
import { useDispatch } from "react-redux";
import { appFeedBackModal, appLevelFeedback, feedBackCheck } from "../Services/Redux/Reducers/feedBackSlice";
import { Cookies } from 'react-cookie-consent';

const ApplicationFeedback = () => {
  const [isLike, setIsLike] = useState(false);
  const [isDislike, setIsDislike] = useState(false);
  const [isDislikeModalOpen, setIsDislikeModalOpen] = useState(false);
  const navigate = useNavigate()
  const dispatch = useDispatch()
  const accessedAppName = Cookies?.get('app_name') ? Cookies.get('app_name') : "";
  const customerId = Cookies?.get('ar_user_Id') ? Cookies.get('ar_user_Id') : "";
  const location = useLocation()

  const handleClose = useCallback((status = "") => {
    dispatch(appFeedBackModal(false));
    if (location.pathname === '/chat') {
      navigate("/");
    }
    if (status === 'closed') {
      let params = {
        userId: customerId,
        requestDateTime: new Date().toString(),
        feedBack: '',
        status: 'closed',
        appName: accessedAppName,
      };
      try {
        saveAppLevelFeedBack(params, (response) => { // Chat History storing the messages      
          if (response.status === 200) {
            dispatch(appLevelFeedback(response.data));
            dispatch(feedBackCheck(false));
          }
        }, (err) => {
          dispatch(apiError("An error occurred. Please try again"));
        });
      } catch(err) {
        dispatch(apiError("An error occurred. Please try again"));
      }
    }
  }, [dispatch, location.pathname, navigate, customerId]);

  const updateRes = useCallback((status) => {
    if (status === undefined) {
      status = "Other Issues";
    }
    let params = {
      userId: customerId,
      requestDateTime: new Date().toString(),
      feedBack: status === 'like' ? '' : status,
      status: status === 'like' ? status : 'dislike',
      appName: accessedAppName,
    };
    try {
      saveAppLevelFeedBack(params, (response) => {
        if (response.status === 200) {
          dispatch(appLevelFeedback(response.data));
          dispatch(feedBackCheck(false));
          handleClose();
        }
      }, (err) => {
        dispatch(apiError("An error occurred. Please try again"));
      });
    } catch(err) {
      dispatch(apiError("An error occurred. Please try again"));
    }
  }, [customerId, dispatch, handleClose]);

  const handleLike = useCallback((status) => {
    updateRes(status);
    setIsLike((prev) => !prev);
    setIsDislike(false);
  }, [updateRes]);

  const handleDislike = useCallback((status) => {
    setIsDislike((prev) => !prev);
    setIsLike(false);
    setIsDislikeModalOpen(true);
  }, []);

  const handleDislikeModalClose = useCallback(() => {
    setIsDislikeModalOpen(false);
  }, []);

  return (
    <div>
        <div className="modal d-flex feedback-fade-in" id="myModal" role="dialog">
          <div className="modal-content feedback-content">
            <button
              name="closeButton"
              type="button"
              className="close_btn align-self-end"
              data-bs-dismiss="modal"
              aria-label="Close"
              onClick={() => handleClose('closed')}
            >
              <img
                height="14px"
                width="14px"
                src="./static/assets/Close_icon.svg"
              />
            </button>
            <div className="modal-content_inner">
              <div className="modal-body">
                <div className="headline pb-3">
                  We Want to Hear from You
                </div>
                <div className="feedback-subtext pb-3">
                  Shape the future of Ask Ralph by providing your feedback and insights as you explore the experience.
                </div>
                <div
                  className="d-flex  justify-content-center"
                  style={{ gap: "12px" }}
                >
                  <button name="thumbsUp" className="feedback-icon">
                    <img
                      height="17.88px"
                      width="17.88px"
                      src={
                        !isLike
                          ? "./static/assets/DesktopThumbsUp.svg"
                          : "./static/assets/likeSolid.svg"
                      }
                      alt="like"
                      onClick={() => handleLike(!isLike ? "like" : "")}
                    />
                  </button>
                  <button name="thumbsDown" className="feedback-icon">
                    <img
                      height="17.88px"
                      width="17.88px"
                      src={
                        !isDislike
                          ? "./static/assets/DesktopThumbsDown.svg"
                          : "./static/assets/dislikeSolid.svg"
                      }
                      alt="dislike"
                      onClick={() => handleDislike(!isDislike ? "dislike" : "")}
                    />
                  </button>
                </div>
              </div>
            </div>
          </div>
        </div>
      {isDislike && (
        <DislikeModule
          isDislikeModalOpen={isDislikeModalOpen}
          handleClose={handleDislikeModalClose}
          updateRes={updateRes}
        />
      )}
    </div>
  );
};

export default memo(ApplicationFeedback);
